import { useRef } from 'react'

export const useHasChangedSinceLastRender = (value: unknown): boolean => {
  const lastValueRef = useRef(value)
  const hasChanged = value !== lastValueRef.current
  lastValueRef.current = value
  return hasChanged
}
